module.exports = __webpack_public_path__ + "img/vae_large.56eabe8e.jpg";